import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Youtube: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="18"
            viewBox="0 0 26 18"
            fill="none"
        >
            <path d="M25.0651 2.81639C24.7707 1.7078 23.9032 0.834703 22.8018 0.538406C20.8054 0 12.8 0 12.8 0C12.8 0 4.7947 0 2.79825 0.538406C1.69683 0.83475 0.829359 1.7078 0.534938 2.81639C0 4.82578 0 9.01819 0 9.01819C0 9.01819 0 13.2106 0.534938 15.22C0.829359 16.3286 1.69683 17.1653 2.79825 17.4616C4.7947 18 12.8 18 12.8 18C12.8 18 20.8053 18 22.8018 17.4616C23.9032 17.1653 24.7707 16.3286 25.0651 15.22C25.6 13.2106 25.6 9.01819 25.6 9.01819C25.6 9.01819 25.6 4.82578 25.0651 2.81639ZM10.1818 12.8246V5.2118L16.8727 9.01828L10.1818 12.8246Z" 
                fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Youtube);
